module.exports = __webpack_public_path__ + "img/4eac2a4.jpg";